import type { ReactNode } from "react";
import { cn } from "../../lib/utils.ts";

interface FullscreenArtifactScrollProps {
  maximized: boolean;
  children: ReactNode;
  className?: string;
  /** Override the inline (non-maximized) height cap. Defaults to `max-h-96`. */
  inlineMaxHeightClassName?: string;
}

/**
 * Scroll container for heavy-artifact content. Encodes the rule:
 * - Inline (non-maximized): bounded by `max-h-96` with its own scroll.
 * - Desktop maximized: bounded by `calc(100vh-20rem)` inside the floating dialog.
 * - Mobile maximized: unbounded — the parent Dialog's flex-1 scroll container
 *   handles scrolling so the fullscreen view reaches the Send/Cancel footer
 *   and Safari's dynamic bottom toolbar doesn't clip the inner scroll box.
 */
export const FullscreenArtifactScroll = ({
  maximized,
  children,
  className,
  inlineMaxHeightClassName = "max-h-96",
}: FullscreenArtifactScrollProps) => {
  return (
    <div
      className={cn(
        "h-fit overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 transition-[max-height] duration-500 ease-in-out",
        maximized ? "md:max-h-[calc(100vh-20rem)]" : inlineMaxHeightClassName,
        className,
      )}
    >
      {children}
    </div>
  );
};
